export const FIREBASE_COLLECTIONS = {
    USERS: "usersNew",
    CLASSES: "classes",
    CONTENT_BOXES: "contentBoxes",
    SEO_ARTICLES: "seoArticles",
    SEO_KEYWORDS: "seoKeywords",
    PRE_MADE_PLAYLISTS: "preMadePlaylists",
    DAILY_CONTENT: "dailyContent",
    AUTOMATION_SEQUENCES: "automationSequences",
    AUTOMATION_HEALTH_DAILY: "automationHealthDaily",
    QUICK_AUTOMATIONS: "quickAutomations",
    TEACHER_HUB_EVENTS: "teacherHubEvents",
    DAILY_SCHEDULES: "dailySchedules",
    SCHEDULE_ASSIGNMENTS: "scheduleAssignments",
    CLASS_STYLE_SCHEMES: "classStyleSchemes",
    SOUND_MONITOR_SESSIONS: "soundMonitorSessions",
    ENGAGEMENT_EVENTS: "engagementEvents",
    EVENTS: "events",
    LIVE_OFFICE_HOURS: "liveOfficeHours",
    LIVE_OFFICE_HOURS_SESSIONS: "liveOfficeHoursSessions",
    LEARNING_SERIES: "learningSeries",
    LEARNING_OCCURRENCES: "learningOccurrences",
    LEARNING_OCCURRENCE_SECRETS: "learningOccurrenceSecrets",
    LEARNING_RECORDINGS: "learningRecordings",
    LEARNING_CENTER_SETTINGS: "learningCenterSettings",
    USER_PRESENCE: "userPresence",
    ADMIN_GROWTH_SIMULATOR: "adminGrowthSimulator",
    MOBILE_SIGNUP_HANDOFFS: "mobileSignupHandoffs",
  };
